import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from 'services/mixpanel'

export const usePageTracking = () => {
	const location = useLocation()
	const prevPath = useRef<string | null>(null)

	useEffect(() => {
		if (prevPath.current === location.pathname) return
		prevPath.current = location.pathname
		trackPageView(location.pathname)
	}, [location.pathname])
}
